import Divider from "@/components/ui/Divider";
import { useAppFeatures } from "@/hooks/useAppFeatures";

import { twMerge } from "tailwind-merge";

import FilterByAnalysisArea from "../filterByGrid";
import Overview from "../overview";

export type ReportSummaryProps = {
  className?: string;
  isExpanded: boolean;
  chartRef: React.RefObject<HTMLDivElement>;
  dynamicChartRef: React.RefObject<(HTMLDivElement | null)[]>;
  isFetching: boolean;
  isError: boolean;
  onRefetch?: () => void;
};

export const ReportSummary = ({
  className,
  isExpanded,
  chartRef,
  dynamicChartRef,
  isFetching,
  isError,
  onRefetch
}: ReportSummaryProps) => {
  const { isDatasetWidgetEnabled } = useAppFeatures();

  const containerExpandedClass = isDatasetWidgetEnabled
    ? "gap-10 flex-col"
    : "gap-10 2xl:flex-col";
  const sectionExpandedClass = isDatasetWidgetEnabled
    ? "w-full"
    : "w-1/2 2xl:w-full";

  return (
    <div
      className={twMerge(
        className,
        isExpanded ? containerExpandedClass : "flex-col"
      )}
    >
      <div className={twMerge(isExpanded ? sectionExpandedClass : "")}>
        <Overview
          isExpanded={isExpanded}
          chartRef={chartRef}
          isFetching={isFetching}
          isError={isError}
          onRefetch={onRefetch}
        />
      </div>

      <div className={twMerge(isExpanded ? sectionExpandedClass : "")}>
        {!isExpanded && (
          <Divider className="bg-white-smoke border-none w-full min-h-[8px] my-4 [&>div]:border-0" />
        )}

        <FilterByAnalysisArea
          isExpanded={isExpanded}
          dynamicChartRef={dynamicChartRef}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
};
